import { ChangeDetectorRef, Component, effect, inject } from '@angular/core';
import { Api } from '../../services/api';
import { toSignal } from '@angular/core/rxjs-interop';
import { LocalDataSource, Settings, Angular2SmartTableModule } from 'angular2-smart-table';
import { Loader } from '../../components/loader/loader';

@Component({
  selector: 'app-meta-particles',
  imports: [Angular2SmartTableModule, Loader],
  templateUrl: './meta-particles.html',
  styleUrl: './meta-particles.css',
})
export class MetaParticles {
  private readonly api = inject(Api);
  private readonly cdr = inject(ChangeDetectorRef);
  protected readonly metaParticles = toSignal<MetaParticle[] | null>(this.api.getMetaParticles(), { initialValue: null });
  protected readonly source = new LocalDataSource();

  constructor() {
    effect(() => {
      this.source.load(this.metaParticles() ?? []);
      queueMicrotask(() => this.cdr.detectChanges());
    });
  }

  settings: Settings = {
    actions: false,
    columns: {
      name: { title: 'Name' },
      id: { title: 'Id' },
      user_context: {
        title: 'Simulation Deck',
        valuePrepareFunction: (uc: UserContext) => uc.simulation_type,
      },
      layout_table: {
        title: 'Particles',
        valuePrepareFunction: (mpi: MetaParticleItem[]) =>
          '[' + mpi.map((item) => item.particle_id).join(', ') + ']',
      },
    },
  };
}
